// src/auth/msalInstance.js
import { PublicClientApplication } from '@azure/msal-browser';

/**
 * Default instance used by <MsalProvider> (Granules India / IN tenant).
 * The LoginPage creates the US instance on-demand via getMsalInstance()
 * to avoid localStorage cache conflicts between two static instances.
 */
export const msalInstance = new PublicClientApplication({
  auth: {
    // Fall back to the original vars if the _IN vars aren't loaded yet
    clientId:
      process.env.REACT_APP_CLIENT_ID_IN || process.env.REACT_APP_CLIENT_ID,
    authority:
      process.env.REACT_APP_AUTHORITY_IN || process.env.REACT_APP_AUTHORITY,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
});
